import Dropdown from "../ui/Dropdown";
import Button from "../ui/Button";
import TextInput from "../ui/TextInput";
import styles from "./FilterBar.module.css";

const FilterBar = ({
  filtersConfig = [],
  filters,
  setFilters,
  onApply,
  onClear,
  className,
  customFilters
}) => {
  const handleChange = (key, selected) => {
    const values = Array.isArray(selected)
      ? selected.map((opt) => (opt && typeof opt === "object" && "value" in opt ? opt.value : opt))
      : selected !== undefined && selected !== null && selected !== ""
      ? [selected]
      : [];
    setFilters((prev) => ({
      ...prev,
      [key]: values,
    }));
  };

  const handleTextChange = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  return (
    <div className={[styles.card, className].filter(Boolean).join(" ")}>

      {/* Filters */}
      <div className={styles.filters}>
        {customFilters}

        {filtersConfig.map((filter, i) => (
          <div key={i} className={styles.filter}>

            <label className={styles.label}>
              {filter.label}
            </label>

            {filter.type === "text" ? (
              <TextInput
                value={filters[filter.key] ?? ""}
                onChange={(e) =>
                  handleTextChange(filter.key, e.target.value)
                }
                placeholder={filter.placeholder || `Enter ${filter.label}`}
                clearable
              />
            ) : (
              <Dropdown
                isMulti={filter.isMulti !== false}
                options={filter.options ?? []}
                value={filters[filter.key] ?? []}
                onChange={(selected) =>
                  handleChange(filter.key, selected)
                }
                placeholder={filter.placeholder || "Select..."}
              />
            )}
          </div>
        ))}

      </div>

      {/* Actions */}
      <div className={styles.actions}>
        <Button type="button" onClick={onApply}>
          Apply Filters
        </Button>

        <Button type="button" onClick={onClear} variant="outline">
          Clear
        </Button>
      </div>

    </div>
  );
};

export default FilterBar;
